import React, { useEffect, useState } from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { apiLink } from "../../helpers/constantVariables";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import HelpCenter from "../reusble_components/helpCenter";
import Footer from "./Footer";
import {
  getclusterbyDomain,
  getLogoBySubdomain,
} from "../../services/white_label";

import Register from "../dashboard/register";
import {
  getDataFromLocalStorage,
  removeDataFromLocalStorage,
} from "../../services/localStorage";
import { apiPostPut, apiPostPutPublic } from "../../api/api_methods";
import { useStores } from "../../store";
import EmailSent from "./emailSent";
import Mail from "../reusble_components/login/mail";
import { MdArrowBackIosNew } from "react-icons/md";
import Selectone from "../reusble_components/login/select one";
import { FcGoogle } from "react-icons/fc";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import NewPlatformPopup from "../reusble_components/popup/NewPlatformPopup";
export default function RegisterForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  // const employer = queryParams.get("employer");
  const url = window.location.href;
  const clusterId = url.split("clusterId=")[1];
  const [hasReferralCode, setHasReferralCode] = useState(referal);
  const group = new URLSearchParams(window.location.search).get("group");
  console.log("hello", group);
  const { PopupStore } = useStores();
  const [employer, setEmployer] = useState(queryParams.get("employer"));
  const [isEmployer, setIsEmployer] = useState(false);
  const setEmployerValue = (value) => {
    console.log("is orgination ", value);
    setIsEmployer(value ? true : false);
    setEmployer(value);
  };
  const [loading, setloading] = useState(false);
  const [showTermAndConditions, setshowTermAndConditions] = useState(
    localStorage.getItem("register")
  );
  const [register, setRegister] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(false);
  const [showNewPlatformPopup, setShowNewPlatformPopup] = useState(false);  
  const [newUserDetails, setnewUserDetails] = useState({});
  const [rcode, setRcode] = useState("");
  const checkForTheUserCredentials = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const user_google = JSON.parse(localStorage.getItem("user_google"));
    if (user) {
      loginUser(user_google?.email, user_google?.sub, user_google?.name);
      console.log(user);

      return navigateUsingRole(user?.role?.role);

      // navigate("/dashboard/settings");
    } else if (user_google) {
      loginUser(user_google?.email, user_google?.sub, user_google?.name);
    }
  };

  useEffect(() => {
    checkForTheUserCredentials();
    gettingParmsFromUrl();
  }, []);
  var referal = false;
  const gettingParmsFromUrl = () => {
    const url = window.location.href;
    const urlParams = new URL(url);
    const referalCode = urlParams.searchParams.get("refer");
    console.log(referalCode);
    setRcode(referalCode);
    if (referalCode) {
      setHasReferralCode(true);
    }
  };

  const registerUser = async (name, mail, gId, pic) => {
    const body = {
      name: name,
      mail: mail,
      gId: gId,
      role: employer ? employer : "647ce2e8c41bee677ea39fc4",
      pic: pic,
      rCode: rcode,
    };

    if (!localStorage.getItem("register")) {
      try {
        setloading(true);
        let newBody = body;
        newBody = {
          ...newBody,
          cluster: getclusterbyDomain(),
        };
        axios
          .post(`${apiLink}/user/register?groupId=${group}`, newBody)
          .then((res) => {
            setloading(false);
            console.log(res);
            if (res.status === 200) {
              localStorage.setItem("user", JSON.stringify(res?.data?.data));
              return;
            }
            alert("Something went wrong. Please try again later. error: 25");
          })
          .catch((err) => {
            setloading(false);
            console.log(err);
            alert("Something went wrong. Please try again later. error: 29");
          });
      } catch (error) {
        console.error(error);
        alert("Something went wrong. Please try again later. error: 33");
      }
    }
  };

  const navigateUsingRole = async (role) => {
    // get the redirect url from local storage

    /* ------------------- REDIRECT TO THE URL IF IT IS THERE ------------------- */
    const redirectUrl = await getDataFromLocalStorage("redirectUrl");
    console.log(redirectUrl);
    if (redirectUrl) {
      removeDataFromLocalStorage("redirectUrl");
      window.location.href = redirectUrl;
      return;
    }

    /* ----------------------------------- XXX ---------------------------------- */

    switch (role) {
      case "student":
        return navigate("/dashboard/dashboard");
      case "company":
      case "consultancy":
        return navigate("/company/dashboard");

      default:
        return navigate("/dashboard/dashboard");
        break;
    }
  };

  const loginUser = async (mail, gId, name, pic) => {
    const body = {
      mail: mail,
      gId: gId,
    };
    try {
      setloading(true);
      let newBody = body;
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };

      const response = await axios
        .post(`${apiLink}/user/login-with-google`, newBody)
        .then(async (res) => {
          setloading(false);
          console.log("id", res.data);
          if (res.status === 200) {
            localStorage.setItem("user", JSON.stringify(res?.data?.data));

            console.log("in", group);

            console.log("id1", res?.data.data._id);
            if (group) {
              const resp = await axios
                .post(
                  `${apiLink}/user/add-user-to-group?userId=${res?.data.data._id}&groupId=${group}`,
                  {}
                )
                .then((result) => {
                  if (result.status === 200) {
                    alert("sucessfully added into the group");
                  }
                });
            }

            if(res?.data?.data?.role?.role === "student" && getDomainForWhiteLabeling() === "app.reaidy.io"){
              setPendingNavigation(res?.data?.data?.role?.role);
              setShowNewPlatformPopup(true);
              return;
            }

            return navigateUsingRole(res?.data?.data?.role?.role);
            // return navigate("/dashboard/dashboard");
          }
          alert("Something went wrong. Please try again later. error: 47");
        })
        .catch((err) => {
          setloading(false);
          console.log(err);
          if (err.response.status === 400) {
            // alert("1")
            PopupStore.setTitle(err.response?.data?.title);
            PopupStore.setMessage(err.response.data.message);
            localStorage.removeItem("user_google");
            PopupStore.setAlert(true);
            // alert(err.response.data.message);
          }
          if (err.response.status === 404) {
            // registerUser(name, mail, gId, pic);

            setnewUserDetails({
              name: name,
              mail: mail,
              gId: gId,
              role: "647ce2e8c41bee677ea39fc4",
              pic: pic,
            });

            setshowTermAndConditions(true);

            // const wouldYoulikeToSignUp = window.confirm(
            //   "You are not registered yet. Would you like to sign up?"
            // );
            // if (wouldYoulikeToSignUp) {
            //   registerUser(name, mail, gId);
            // }
          }
        });
    } catch (error) {
      console.error(error);
    }
  };

  const onSuccessLogin = (response) => {
    const userObject = jwt_decode(response.credential);
    console.log("userObject", userObject);

    if (employer) {
      // write condition
      const email = userObject?.email;
      const professionalEmailRegex = /^[^\s@]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
      const genericDomainRegex =
        /@(gmail|yahoo|hotmail|outlook|aol|icloud|protonmail|zoho)\.com$/;

      if (!professionalEmailRegex.test(email)) {
        alert("Please enter a valid email address.");
        return;
      }

      if (genericDomainRegex.test(email)) {
        PopupStore.setTitle("Invalid Email");
        PopupStore.setMessage(
          `please enter a professional email address (generic email domains are not allowed).`
        );
        PopupStore.setAlert(true);

        return;
      }
    }

    localStorage.setItem("user_google", JSON.stringify(userObject));
    loginUser(
      userObject?.email,
      userObject?.sub,
      userObject?.name,
      userObject?.picture
    );
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => onSuccessLogin(tokenResponse),
    onError: (error) => {
      console.log(error);
    },
  });

  function submitButton() {
    return (
      <button
        disabled={!enableSubmit}
        className={`gil-reg text-lg ${
          enableSubmit ? "bg-primary" : " bg-slate-300"
        } text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full`}
        onClick={() => {
          if (hasReferralCode && rcode === "") {
            alert("Please enter a referral code");
            return;
          }
          setshowTermAndConditions(false);
          setRegister(true);
          registerUser(
            newUserDetails.name,
            newUserDetails.mail,
            newUserDetails.gId,
            newUserDetails.pic
          );
        }}
      >
        Continue
      </button>
    );
  }

  const termsAndConditionsWithSubmitButton = () => {
    return (
      <div className="flex flex-col items-center justify-center md:justify-start w-[90%] lg:w-[50%] md:w-[50%] md:space-y-3 h-full  ">
        <div className=" flex flex-col justify-center items-center h-full">
          <div
            className="flex items-center justify-start mb-[25%] md:mb-[40%] -mt-[10%] w-full cursor-pointer  "
            onClick={() => {
              navigate(-1);
            }}
          >
            <MdArrowBackIosNew className="text-black text-sm mr-1" />
            <span className="text-xs text-black font-bold">Back</span>
          </div>
          <img src={getLogoBySubdomain(true)} className="w-48 mb-10" />
          <div className="flex items-center  space-x-2 text-xl pb-0 md:pb-2 lg:pb-2">
            <input
              type="checkbox"
              id="acceptTerms"
              className="text-primary h-5 w-5 "
              onChange={(e) => {
                setEnableSubmit(e.target.checked);
              }}
            />
            <label
              htmlFor="acceptTerms"
              className="flex gap-2 items-center justify-center"
            >
              <p className="whitespace-nowrap">I accept the </p>
              <a
                href="https://www.reaidy.in/page-terms.html"
                target="_blank"
                className="text-primary hover:underline whitespace-nowrap"
              >
                Terms and Conditions
              </a>
            </label>
          </div>
          {/* <div className="h-24 py-3">
            <div className="flex space-x-4">
              <p>Do you Have a Referal Code</p>
              <label>
                <input
                  type="radio"
                  value="yes"
                  checked={hasReferralCode}
                  onChange={() => setHasReferralCode(true)}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  value="no"
                  checked={!hasReferralCode}
                  onChange={() => setHasReferralCode(false)}
                />
                No
              </label>
            </div>
            {hasReferralCode && (
              <div>
                <input
                  required
                  disabled={!enableSubmit}
                  type="text"
                  className="border-2 px-2 py-2 border-gray-800 rounded-lg opacity-75 tracking-[3px] border-opacity-50 mt-2"
                  placeholder="Referal code"
                  value={rcode}
                  onChange={(e) => {
                    setRcode(e.target.value);
                    console.log(rcode);
                  }}
                />
              </div>
            )}
          </div> */}
          <div className="w-[90%]">{submitButton()}</div>
        </div>
      </div>
    );
  };
  const [warn, setWarn] = useState(false);

  const handleNewPlatformCancel = () => {
    setShowNewPlatformPopup(false);
  };

  const handleNewPlatformConfirm = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    localStorage.clear();
    if(pendingNavigation === "student"){
      window.location.href = `https://user.reaidy.io/${user._id}`;
      return;
    }
  };
    
  
  return (
    <>
      <NewPlatformPopup
            isOpen={showNewPlatformPopup}
            onClose={handleNewPlatformCancel}
            onConfirm={handleNewPlatformConfirm}
            onCancel={handleNewPlatformCancel}
          />
      {register ? (
        <>
          <Register
            onBack1={() => {
              setRegister(false);
              setshowTermAndConditions(true);
              console.log("back");
            }}
          />
          <HelpCenter position="/" />
        </>
      ) : (
        <div className="flex flex-col items-center justify-center mx-auto md:w-full lg:w-full w-[100%] h-screen bg-[#F8F2E9] gil-reg tc1:px-10">
          <Loader loader={loading} />
          {/* <img
            src={getLogoForWhiteLabeling()}
            className=" w-[300px] md:w-[300px] lg:w-[400px] object-cover mb-5 md:mt-auto"
            alt="logo"
          /> */}
          {/* <h1 className="text-3xl gil-bold mb-8">Sign up for an account</h1> */}
          {showTermAndConditions ? (
            termsAndConditionsWithSubmitButton()
          ) : (
            <div className="flex flex-col gap-5 justify-center md:mt-auto">
              {/* <span className="spanWithLines font-semibold opacity-80">
                Or register with email
              </span> */}
              <EmailSent />
              <form
                className="flex flex-col gap-5 tc1:w-80 md:w-96"
                onSubmit={async (e) => {
                  e.preventDefault();
                  setloading(true);
                  // email validation
                  const email = document.getElementById("email").value;
                  if (!email.includes("@") || !email.includes(".")) {
                    PopupStore.setTitle("Invalid Email");
                    PopupStore.setMessage("Please enter a valid email");
                    PopupStore.setAlert(true);
                    // PopupStore.setEmailPopup(true);

                    setloading(false);
                    return;
                  }

                  if (employer) {
                    const email = document.getElementById("email").value;
                    const professionalEmailRegex =
                      /^[^\s@]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
                    const genericDomainRegex =
                      /@(gmail|yahoo|hotmail|outlook|aol|icloud|protonmail|zoho)\.com$/;

                    if (!professionalEmailRegex.test(email)) {
                      alert("Please enter a valid email address.");
                      setloading(false);
                      return; // Stop further execution
                    }

                    if (genericDomainRegex.test(email)) {
                      PopupStore.setTitle("Invalid Email");
                      PopupStore.setMessage(
                        "please enter a professional email address (generic email domains are not allowed)."
                      );
                      PopupStore.setAlert(true);

                      setloading(false);
                      return; // Stop further execution
                    }
                  }

                  const response = await apiPostPutPublic(
                    {
                      email: document.getElementById("email").value,
                      employer: employer ?? employer,
                      clientCluster: clusterId || null,
                    },
                    "/user/send-verification-email",
                    "POST"
                  );
                  if (response.status === 200) {
                    PopupStore.setTitle(response?.body?.title);
                    PopupStore.setMessage(response.body.message);
                    // PopupStore.setAlert(true);
                    PopupStore.setEmailPopup(true);
                    setloading(false);
                    // alert(response.body.message);
                  } else {
                    PopupStore.setTitle(response?.body?.title);
                    PopupStore.setMessage(response.body.message);
                    PopupStore.setAlert(true);
                    setloading(false);
                    // alert(response.body.message);
                  }
                }}
              >
                {/* <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md">
                  <AiOutlineMail className="text-2xl opacity-80 " />
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className=" bg-transparent px-2 py-2 outline-none rounded-lg w-full placeholder:text-black placeholder:opacity-80  tracking-[3px] "
                    placeholder="Enter your email"
                  />
                </div> */}
                <div
                  className="flex items-center justify-start  tc1:mt-10 md:mt-10 tc3:mt-0 tc1:mb-[20%] tc3:mb-[10%] md:mb-[15%] -mt-[10%] w-full cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <MdArrowBackIosNew className="text-black text-sm mr-1" />
                  <span className="text-xs text-black font-bold  ">Back</span>
                </div>
                <Selectone
                  setEmployerValue={(value) => {
                    setEmployerValue(value);
                    if (value) {
                      document.getElementById("email").value = "";
                    }
                  }}
                  isEmployer={isEmployer}
                />
                <div>
                  <h1 className="w-50 h-3 ml-2 font-bold ">
                    {" "}
                    {`${
                      employer ? "Enter Professional" : "Enter Your"
                    } Mail-ID`}
                  </h1>
                  <Mail
                    id="email"
                    name="email"
                    placeholder={
                      employer ? "eg: sneha@tcs.com" : "eg: sneha@gmail.com"
                    }
                  />
                </div>
                {/* <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md">
                  <AiOutlineLock className="text-2xl opacity-80 " />
                  <input
                    type="text"
                    name="password"
                    className=" bg-transparent px-2 py-2 outline-none rounded-lg placeholder:text-black placeholder:opacity-80  tracking-[3px] "
                    placeholder="Password"
                  />
                </div>
                <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md">
                  <AiOutlineLock className="text-2xl opacity-80 " />
                  <input
                    type="text"
                    name="confirmPassword"
                    className=" bg-transparent px-2 py-2 outline-none rounded-lg placeholder:text-black placeholder:opacity-80  tracking-[3px] "
                    placeholder="Confirm Password"
                    onChange={(e) => {
                      if (
                        e.target.value !==
                        document.getElementsByName("password")[0].value
                      ) {
                        setWarn(true);
                      } else {
                        setWarn(false);
                      }
                    }}
                  />
                </div>
                {warn && (
                  <span className="flex items-center">
                    <AiOutlineWarning color="red" /> Your password and
                    confirmation password do not match
                  </span>
                )} */}
                <button
                  type="submit"
                  className="gil-reg text-lg bg-primary text-white px-4 py-2 md:mb-10 tc3:mb-1 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full"
                >
                  Create an account
                </button>
                <span className="mb-5 tc3:mb-0 lg:mb-32 text-center">
                  Already have an account?{" "}
                  <a
                    onClick={() => {
                      navigate("/");
                    }}
                    className="text-primary cursor-pointer"
                  >
                    Login
                  </a>
                </span>
                <span className="text-[#ff6b00] text-center mb-5">OR</span>
                {/* <div className="w-full flex items-center justify-center  -mt-3 rounded-md h-12">
                  <div className="bg-[#FF6B00] text-2xl  rounded-l-md text-white w-[20%] flex items-center justify-center h-12">
                    <FaGoogle />
                  </div>
                  <button
                    className="bg-[#FFFFFF] text-lg text-[#000000] px-4 h-12 rounded-r-md focus:outline-none w-[80%] "
                    // onClick={() => googleLoginRef.current?.click()} // Click hidden GoogleLogin button
                    onClick={() => login()}
                  >
                    Continue with Google
                  </button>
                </div> */}
                <div className="mb-1 tc1:w-80  tc3:w-96 md:w-96 md:pr-0 relative h-[5vh]">
                  <div className=" relative z-0">
                    <div className="bg-[#ffffff] tc1:w-80 md:w-96 h-12 rounded-md absolute pointer-events-none top-0 z-50 flex gap-3 items-center justify-center">
                      <FcGoogle className="text-xl" />
                      <button className=" text-sm text-[#000000] ">
                        Continue with Google
                      </button>
                    </div>
                    {/* Ensure the white div is above */}
                    <GoogleLogin
                      id="google-login"
                      theme="outline"
                      text="continue_with"
                      size="large"
                      shape="rectangular"
                      width={window.innerWidth > 999 ? "383px" : "300px"}
                      logo_alignment="center"
                      onSuccess={(credentialResponse) => {
                        onSuccessLogin(credentialResponse);
                        console.log(credentialResponse);
                      }}
                      onError={() => alert("Login Failed")}
                    />
                  </div>
                </div>
              </form>
            </div>
          )}
          <span></span>

          {/* this is the UI button part starts */}

          {/* <div className="flex mt-5 bg-[#202126] cursor-pointer py-2 pl-10 pr-2 rounded-full relative justify-center" >
            <div className="bg-white mr-2 left-1 top-1 text-2xl absolute rounded-full p-[5px]">
            <FcGoogle className=""/>
            </div>
            <h1 className="text-base ml-2 text-white gil-med">Sign in with Google</h1>
          </div> */}
          {/* the UI  button part Ends */}
          <div className="md:block md:mt-auto flex items-center justify-center md:items-end">
            <Footer className="bg-blue-500 text-white p-6 w-full" />
          </div>
          {/* <HelpCenter position="/" /> */}
          {/* <button
        className="flex items-center bg-white border border-gray-300 rounded-xl px-6 py-4 shadow hover:shadow-md focus:outline-none"
        onClick={login}
      >
        <img
          src="https://github.com/spotmies/images/assets/63062130/6a19d364-9fae-4e55-9069-8b4e7924e124"
          className="object-cover h-6 w-6 mr-2"
          alt="logo"
        />
        <span>Continue with Google</span>
      </button> */}
        </div>
      )}
    </>
    // <div className="w-[95vw] h-[100vh] gil-reg">
    //   <div className="flex flex-row justify-center items-center h-full w-full ">
    //     <GoogleLogin
    //       onSuccess={(credentialResponse) => {
    //         console.log(credentialResponse);
    //         onSuccessLogin(credentialResponse);
    //       }}
    //       onError={() => {
    //         console.log("Login Failed");
    //         alert("Login Failed");
    //       }}
    //     />
    //   </div>
    // </div>
  );
}
